import {
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
} from '../../../integrated-client/models';
import {DEFAULT_LIMIT_PAGINATION, DEFAULT_OFFSET, DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFiltersData {
  supplier?: GuidIdAndLabel;
  carrier?: GuidIdCodeAndLabel
  ancillaryCategory?: GuidIdAndLabel
  ancillary?: GuidIdAndLabel
  offset: number;
  limit: number;
  currentPage: number;
  total: number;
}

export class FiltersData implements IFiltersData {
  supplier?: GuidIdAndLabel;
  carrier?: GuidIdCodeAndLabel
  ancillaryCategory?: GuidIdAndLabel
  ancillary?: GuidIdAndLabel
  offset: number;
  limit: number;
  currentPage: number;
  total: number;

  constructor() {
    this.offset = DEFAULT_OFFSET
    this.limit = DEFAULT_LIMIT_PAGINATION
    this.total = DEFAULT_TOTAL_ITEMS
    this.currentPage = 1
  }
}
